import { render, staticRenderFns } from "./OrderPrevious.vue?vue&type=template&id=6c9d497a&"
import script from "./OrderPrevious.vue?vue&type=script&lang=ts&"
export * from "./OrderPrevious.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports